import { render } from "./QuestionsPage.vue?vue&type=template&id=09a2e065&scoped=true&ts=true"
import script from "./QuestionsPage.vue?vue&type=script&lang=ts"
export * from "./QuestionsPage.vue?vue&type=script&lang=ts"

import "./QuestionsPage.vue?vue&type=style&index=0&id=09a2e065&lang=css"
import "./QuestionsPage.vue?vue&type=style&index=1&id=09a2e065&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a2e065"]])

export default __exports__